// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"cf684ec2","90":"ff1cf466","2137":"cf684ec2","3307":"cf684ec2","5066":"cf684ec2","5335":"cf684ec2","6854":"cf684ec2","8134":"cf684ec2"}[chunkId] + ".chunk.css";
};